import reducer from "./reducer";
export { default as ConsentPublication } from "./components";
export { default as consentPublicationReducerName } from "./constants";
export default reducer;
